
export const OPERATOR_AND = 'AND';
export const OPERATOR_OR = 'OR';
export const OPERATOR_EQUAL = '=';
export const OPERATOR_LESSTHAN = '<';
export const OPERATOR_GREATERTHAN = '>';
export const OPERATOR_LESSTHAN_EQUAL = '<=';
export const OPERATOR_GREATERTHAN_EQUAL = '>=';
export const OPERATOR_NOT_EQUAL = '!=';
export const OPERATOR_BETWEEN = 'between';
export const OPERATOR_NOT_BETWEEN = 'notbetween';
export const OPERATOR_IN = 'in';
export const OPERATOR_NOT_IN = 'notin';
export const OPERATOR_NULL = 'null';
export const OPERATOR_NOT_NULL = 'notnull';
export const OPERATOR_LIKE = 'like';
export const OPERATOR_LIKE_CASEINSENSITIVE = 'ilike';



